module.exports = __webpack_public_path__ + "img/mini-logo.d52f29c8.png";